import React from "react";
import EsgContainer from "./EsgContainer";
 
const EsgScan = () => {
  return <EsgContainer page="esg-scan"/>;
};

export default EsgScan;
